import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Alert,
} from '@mui/material';
import Layout from '../components/Layout';
import { tenantService } from '../services/tenantService';

const TenantForm = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(isEdit);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isEdit && id) {
      loadTenant(id);
    }
  }, [isEdit, id]);

  const loadTenant = async (tenantId: string) => {
    try {
      setLoadingData(true);
      setError(null);
      const tenant = await tenantService.getById(tenantId);
      setFormData({
        name: tenant.name,
        description: tenant.description || '',
      });
    } catch (err: any) {
      setError(err.response?.data?.message || 'Şirket grubu yüklenirken bir hata oluştu');
    } finally {
      setLoadingData(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (isEdit && id) {
        await tenantService.update({
          id,
          ...formData,
        });
      } else {
        await tenantService.create(formData);
      }
      navigate('/tenants');
    } catch (err: any) {
      setError(err.response?.data?.message || 'İşlem sırasında bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/tenants');
  };

  if (loadingData) {
    return (
      <Layout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Typography variant="h4" component="h1" gutterBottom>
        {isEdit ? 'Şirket Grubu Düzenle' : 'Yeni Şirket Grubu Oluştur'}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Paper sx={{ p: 3, mt: 2 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Şirket Grubu Adı"
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            margin="normal"
            placeholder="Şirket grubu adını giriniz"
          />

          <TextField
            fullWidth
            label="Açıklama"
            multiline
            rows={4}
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            margin="normal"
            placeholder="Şirket grubu açıklamasını giriniz"
          />

          <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <Button
              variant="outlined"
              onClick={handleCancel}
              disabled={loading}
            >
              İptal
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : isEdit ? 'Güncelle' : 'Oluştur'}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Layout>
  );
};

export default TenantForm;

